import { useQuery } from '@tanstack/react-query';
import {
  productClientsService,
  type ProductClientListParams,
} from '../services/product-clients.service';

export function useProductClients(params: ProductClientListParams) {
  return useQuery({
    queryKey: ['product-clients', params],
    queryFn: () => productClientsService.list(params),
    enabled: !!params.productId,
  });
}

export function useProductClientStats(productId: number | null) {
  return useQuery({
    queryKey: ['product-clients-stats', productId],
    queryFn: () => productClientsService.stats(productId as number),
    enabled: !!productId,
  });
}
